import { toast } from 'react-toastify';
import { BulkAssignmentCase, BulkAssignmentPayloadOperation, CaseUserGroup } from '@/api/apis/case';
import { usePatchBulkAssignment } from '@/queries/case';
import { retrieveUnifiedError } from '@/api/utils';
import { getActionByFiltersState } from '../utils';
import { BulkAssignmentFiltersType } from '../types';

interface UseStartBulkAssignmentProps {
  selectedItems: BulkAssignmentCase[];
  filters: BulkAssignmentFiltersType;
  isPrimary: boolean;
  setSelectedCases: (cases: Record<string, BulkAssignmentCase>) => void;
  startRun: (correlationId: string, expectedTotal: number) => void;
}

export const useStartBulkAssignment = ({
  selectedItems,
  filters,
  isPrimary,
  setSelectedCases,
  startRun,
}: UseStartBulkAssignmentProps) => {
  const { mutateAsync, isPending } = usePatchBulkAssignment();

  const handleBulkAssign = async () => {
    const payload: BulkAssignmentPayloadOperation[] = selectedItems.map((item) => ({
      $type: getActionByFiltersState(filters),
      caseId: item.caseId,
      assigningEmployeeId: filters.employeeIdsToAssign[0],
      detachedEmployeeId: filters.employeeIdsToDetach[0],
      group: filters.group[0],
      assignAsPrimary: filters.group[0] === CaseUserGroup.SrLogisticsManagers ? null : isPrimary,
    }));

    try {
      const { correlationId } = await mutateAsync(payload);
      startRun(correlationId, payload.length);
      setSelectedCases({});
    } catch (error) {
      toast.error(retrieveUnifiedError(error, 'Failed to start bulk assignment').message);
    }
  };

  return {
    handleBulkAssign,
    isAssignRequestPending: isPending,
  };
};
